import {FrontWebSongModel} from "../../../../../generated";
import NowModule from "./Now.module.scss";
import { LyricsLink} from "../../../../../components/Item/Song/LyricsLink";
import { LogoRow} from "../../../../../components/Item/Image/LogoRow";
import React from "react";

type Props = {
    now?: FrontWebSongModel
    className?: string,
    color?: string
}

export const Now = (props: Props) => {
    if (!props.now || !props.now.active)
        return null;

    const styl = (() => {
        if (props.color) {
            return {
                color: props.color
            }
        }
        return {};
    })();

    const content = <>
        <span className={`${NowModule.PlayNow} mt-3`} style={styl}>Právě hraje</span>
        <LogoRow  className={`${NowModule.ImgSong} mt-3 `}  src={props.now.image || "https://cdb.radia.cz/design/img/thumbnails/no-artwork-image(image400).png"} alt={`${props.now.interpret}, ${props.now.song}`} />
        <strong className={`mt-3 me-auto ms-auto`}>{props.now.interpret}</strong>
        <span className={`mt-2`}>{props.now.song}</span>
    </>

    if (props.now.lyricsRadioSlug) {
        return <LyricsLink song={props.now}  className={`d-flex flex-column ${NowModule.Song} ${props.className}`}>
            {content}
        </LyricsLink>
    }

    return <div className={`d-flex  flex-column ${NowModule.Song} ${props.className}`}>
        {content}
    </div>
}